import { AuthenticationService } from './../../_services/authentication.service';
import { CachedDataService } from './../../auth/_core/cached-data.service';
import { Converters } from './../../auth/_utilities/converters';
import { Pet } from './../../auth/_models/pet';
import { BlockUi } from './../../auth/_helpers/block-ui';
import { PetsService } from './../../auth/_services/pets.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Pelage } from './../../auth/_models/pelage';
import { Breed } from './../../auth/_models/breed';
import { Species } from './../../auth/_models/species';
import { Gender } from './../../auth/_models/gender';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { Guardian } from '../../auth/_models/guardian';
import { User } from '../../auth/_models/user';
import { Right } from './../../auth/_models/right';
import { UtilService } from 'src/app/auth/_services/util.service';
import { Address } from 'src/app/auth/_models/address';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UsersService } from 'src/app/auth/_services/users.service';

declare let CustomScript: any;

@Component({
  selector: 'app-pet-detail-data',
  templateUrl: './pet-detail-data.component.html',
  styleUrls: ['./pet-detail-data.component.css'],
  providers: [UtilService, UsersService]
})
export class PetDetailDataComponent implements OnInit, AfterViewInit, OnDestroy {

  user: User;

  unSubscribe = new Subject;

  pet: Pet = new Pet({});

  formCreate: FormGroup;

  sending: boolean;

  erroCep = false;

  newAddress: Address;

  genderList: Array<Gender> = null;
  speciesList: Array<Species> = null;
  breedsList: Array<Breed> = null;
  pelageList: Array<Pelage> = null;

  constructor(
    private _utilService: UtilService,
    private _formBuilder: FormBuilder,
    private _blockui: BlockUi,
    private _service: PetsService,
    private _tostr: ToastrService,
    private _route: ActivatedRoute,
    private _authService: AuthenticationService,
    private _userService: UsersService,
    private _router: Router,
    private _cachedService: CachedDataService,
  ) {

    this.formCreate = _formBuilder.group({
      name: [null, [Validators.required]],
      birthday: [null, [Validators.required]],
      gender: [null, [Validators.required]],
      species: ['', [Validators.required]],
      breed: ['', [Validators.required]],
      pelage: ['', [Validators.required]],
      color: ['', [Validators.required]],
      note: [null, []],
      guardianData: _formBuilder.group({
        name: [null, [Validators.required]],
        document: [null, [Validators.required]],
        phone: [null, [Validators.required]],
        email: [null, [Validators.required]],
        guardianBirthday: [null, [Validators.required]],
        guardianZipCode: [null, [Validators.required]],
        guardianStreet: [null, [Validators.required]],
        guardianAddressDetail: [null],
        guardianStreetNumber: [null, [Validators.required]],
        guardianNeighborhood: [null, [Validators.required]],
        guardianCity: [null, [Validators.required]],
        guardianState: [null, [Validators.required]],
      })
    });

    this.speciesList = _cachedService.speciesList;
    this.genderList = _cachedService.genderList;
    this.pelageList = _cachedService.pelageList;
    // this.breedsList = [];
    // this.breedsList.push(new Breed({ uuid: '1', name:"Carregando" }));

    // this.selectSpecies('felino');

    // console.log('this.breedsList');
    // console.log(this.breedsList);

    // console.log('this.genderList');
    // console.log(this.speciesList);

  }

  getAddress() {
    this._utilService
      .getAddressByZipCode
      (this.getControl('guardianData.guardianZipCode').value).pipe(takeUntil(this.unSubscribe))
      .subscribe(addressObj => {
        if (addressObj.erro) {
          this.erroCep = true;
          this.newAddress = null;
          // console.log(addressObj.erro);
        } else {
          if (!this.newAddress) {
            this.newAddress = new Address();
          }
          this.erroCep = false;
          this.newAddress.zipcode = addressObj.cep;
          this.newAddress.street = addressObj.logradouro;
          this.newAddress.neighborhood = addressObj.bairro;
          this.newAddress.city = addressObj.localidade;
          this.newAddress.state = addressObj.uf;
          // console.log(addressObj);
        }
      });
  }

  checkDisabled(control: string) {
    return !this.getControl(control).valid;
  }

  ngOnDestroy() {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }

  ngOnInit() {
    this._route.parent.params.pipe(takeUntil(this.unSubscribe)).subscribe(params => {
      const uuid = params['id'];
      this._service
        .getPet(uuid)
        .valueChanges().pipe(takeUntil(this.unSubscribe))
        .subscribe(p => {

          p.uuid = uuid;

          if (p.birthday) {
            if (typeof p.birthday.toDate === 'function') {
              p.birthday = p.birthday.toDate();
            }
          }

          if (p.guardian) {
            if (p.guardian.birthday) {
              if (typeof p.guardian.birthday.toDate === 'function') {
                p.guardian.birthday = p.guardian.birthday.toDate();
              }
            }
          }

          this.pet = p;
          // console.log(JSON.stringify(this.pet));
          this.newAddress = new Address();
          if (p && p.guardian && p.species) {
            this.newAddress = p.guardian.address;
            this.selectSpecies(p.species.uuid);
          }

          CustomScript.updateUniform();
        });
    });

  }

  ngAfterViewInit(): void {
    CustomScript.initUniform();
  }

  resetForm() {
    this.formCreate.reset();
  }

  getControl(field: string): AbstractControl {
    return this.formCreate.get(field);
  }

  verificaValidTouched(field: string) {
    return (
      !this.getControl(field).valid &&
      (this.getControl(field).touched || this.getControl(field).dirty)
    );
  }

  checkValid(control) {
    return {
      'border-danger': this.verificaValidTouched(control)
    };
  }

  onSubmit() {

    const controls = this.formCreate.controls;
    const self = this;

    let pet: Pet;

    /**
     * Verifica se o formulário é válido
     */

    if (this.formCreate.valid) {

      const name: string = this.getControl('name').value,
        gender: string = this.getControl('gender').value,
        species: string = this.getControl('species').value,
        breed: string = this.getControl('breed').value,
        pelage: string = this.getControl('pelage').value,
        color: string = this.getControl('color').value,
        note: string = this.getControl('note').value,
        guardianName: string = this.getControl('guardianData.name').value,
        guardianPhone: string = this.getControl('guardianData.phone').value,
        guardianEmail: string = this.getControl('guardianData.email').value,
        guardianDocument: string = this.getControl('guardianData.document').value,
        guardianZipCode: string = this.getControl('guardianData.guardianZipCode').value,
        guardianStreet: string = this.getControl('guardianData.guardianStreet').value,
        guardianStreetNumber: string = this.getControl('guardianData.guardianStreetNumber').value,
        guardianNeighborhood: string = this.getControl('guardianData.guardianNeighborhood').value,
        guardianCity: string = this.getControl('guardianData.guardianCity').value,
        guardianAddressDetail: string = this.getControl('guardianData.guardianAddressDetail').value,
        guardianState: string = this.getControl('guardianData.guardianState').value;

      this._blockui.block();

      if (!this.sending) {

        const birthday = new Date(this.getControl('birthday').value);
        birthday.setDate(birthday.getDate() + 1);

        const guardianBirthday = new Date(this.getControl('guardianData.guardianBirthday').value);
        guardianBirthday.setDate(guardianBirthday.getDate() + 1);

        this.sending = true;

        pet = new Pet({
          name: name,
          birthday: birthday,
          gender: new Gender(this.genderList.find(g => g.uuid === gender)),
          species: new Species(this.speciesList.find(s => s.uuid === species)),
          breed: new Breed(this.breedsList.find(b => b.uuid === breed)),
          pelage: new Pelage(this.pelageList.find(p => p.uuid === pelage)),
          color: color,
          note: note,
          guardian: new Guardian({
            birthday: guardianBirthday,
            document: guardianDocument,
            name: guardianName,
            phone: guardianPhone,
            address: new Address({
              zipcode: guardianZipCode,
              street: guardianStreet,
              streetNumber: guardianStreetNumber,
              neighborhood: guardianNeighborhood,
              addressDetail: guardianAddressDetail,
              city: guardianCity,
              state: guardianState
            }),
            user: new User({
              email: guardianEmail,
              right: new Right({
                name: 'Guardian',
                key: 'gdn'
              })
            })
          })
        });

        /** Envia a mensagem para que seja feito o update qdo chega */
        this._service
          .updatePet(pet, this.pet.uuid)
          .then((data) => {
            this._userService.getUserByEmail(pet.guardian.user.email).pipe(takeUntil(this.unSubscribe)).subscribe(users => {

              this._service.updatePetGuardian(users[0].uuid,
                {
                  birthday: guardianBirthday,
                  document: guardianDocument,
                  name: guardianName,
                  phone: guardianPhone,
                  address: {
                    zipcode: guardianZipCode,
                    street: guardianStreet,
                    streetNumber: guardianStreetNumber,
                    neighborhood: guardianNeighborhood,
                    addressDetail: guardianAddressDetail,
                    city: guardianCity,
                    state: guardianState
                  },
                  user: {
                    email: guardianEmail,
                    right: {
                      name: 'Guardian',
                      key: 'gdn'
                    }
                  }
                }
              ).then(() => {
                self._blockui.unblock();
                self.resetForm();
                // self._tostr.success('Pet atualizar com sucesso.');
                self.sending = false;
                // Redirecionando
                // this._router.navigate(['/pets']);
                this._authService.redirect();
              });
            });

          })
          .catch((err) => {
            self._blockui.unblock();
            self._tostr.error('Ocorreu um erro ao atualizar o pet.');
            console.log(err);
            self.sending = false;
          });
      }
    }
  }

  selectSpecies(specie) {

    if (specie !== '') {
      const that = this;

      const cached = this.speciesList.find(s => s.uuid === specie);

      this.formCreate.controls.breed.setValue('');
      this.breedsList = new Array();
      CustomScript.updateUniform();

      if (cached.breeds.length > 0) {
        this.breedsList = cached.breeds;
        CustomScript.updateUniform();
      } else {
        this._service.getBreeds(specie).then((data) => {
          data.forEach(function (item) {
            that.breedsList.push(new Breed({ uuid: item.id, ...item.data() }));
          });
          CustomScript.updateUniform();
        });
      }
    } else {
      this.breedsList = null;
    }
  }
}
